import ReactDom from "react-dom";
import BackToTop from "./BackToTop.jsx";

export default function renderBackToTop() {
  const btnMount = document.createElement("div");
  btnMount.setAttribute("class", "js-back-to-top");

  // only render this if we haven't rendered yet
  if (!document.querySelector(".js-back-to-top")) {
    document.querySelector("body").appendChild(btnMount);
    ReactDom.render(<BackToTop btnText="Back to top" />, btnMount);
  }
}
